import { useQuery } from "@tanstack/react-query";
import treasuryProvider, {
	type TreasurySummary,
} from "src/providers/treasury-provider";

export function useTreasurySummary() {
	return useQuery<TreasurySummary>({
		queryKey: ["treasury-summary"],
		queryFn: () => treasuryProvider.getSummary(),
		staleTime: 30_000,
		refetchInterval: 60_000,
	});
}
